module.exports = __webpack_public_path__ + "media/assets/img/products/studio_europe-selected-fe6f787329539a79d4d33f77b9140c9d.svg";